exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner[data-v-fe2d12de]{text-align:center}.spinner>div[data-v-fe2d12de]{width:10px;height:10px;background-color:#fff;border-radius:100%;display:inline-block;animation:sk-bouncedelay-data-v-fe2d12de 1.4s ease-in-out infinite both}.spinner .bounce1[data-v-fe2d12de]{animation-delay:-.32s}.spinner .bounce2[data-v-fe2d12de]{animation-delay:-.16s}@keyframes sk-bouncedelay-data-v-fe2d12de{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}", ""]);

// exports
